import { LoadingIndicator } from "./LoadingIndicator";
import React, { useState } from "react";

export function LoadingButton({ className, title = "", children, onClickPromise }) {
  const [loading, setLoading] = useState(false);
  if (loading) {
    return <LoadingIndicator />;
  }
  return (
    <div
      className={className}
      title={title}
      onClick={() => {
        setLoading(true);
        onClickPromise().then(() => setLoading(false));
      }}
    >
      {children}
    </div>
  );
}
